import React from 'react';
import { FadeIn } from './FadeIn';
import { AlertTriangle } from 'lucide-react';
export function ProblemAgitation() {
  return <section className="bg-white py-12 md:py-16 px-4 sm:px-6 lg:px-8" data-id="element-113">
      <div className="max-w-3xl mx-auto" data-id="element-114">
        <FadeIn data-id="element-115">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-black mb-8 text-center" data-id="element-116">
            The Uncomfortable Truth Nobody Tells You
          </h2>
        </FadeIn>

        <div className="space-y-6 text-lg text-gray-700 leading-relaxed" data-id="element-117">
          <FadeIn delay={0.1} data-id="element-118">
            <p data-id="element-119">
              Chronic joint pain is not inevitable. It's not simply "age." And
              it definitely doesn't get resolved by taking more pills.
            </p>
          </FadeIn>

          <FadeIn delay={0.2} data-id="element-120">
            <p data-id="element-121">
              Something is happening inside your body that an X-ray can't show.
              Something that standard blood tests don't detect. A silent process
              that started years ago in a place you'd never associate with knee
              pain:
            </p>
          </FadeIn>

          <FadeIn delay={0.3} data-id="element-122">
            <p className="text-2xl font-serif font-bold text-forest-green text-center py-4" data-id="element-123">
              Your gut.
            </p>
          </FadeIn>

          <FadeIn delay={0.4} data-id="element-124">
            <div className="bg-alert-red border-l-4 border-alert-red-border p-6 rounded-r-lg my-8 flex gap-4 items-start" data-id="element-125">
              <AlertTriangle className="w-6 h-6 text-alert-red-text flex-shrink-0 mt-1" data-id="element-126" />
              <p className="text-alert-red-text font-medium" data-id="element-127">
                Every time you take ibuprofen for joint pain, you are damaging
                the same intestinal barrier that is causing that pain. It's a
                vicious cycle that can last decades.
              </p>
            </div>
          </FadeIn>

          <FadeIn delay={0.5} data-id="element-128">
            <p data-id="element-129">
              Meanwhile the supplement industry sells you glucosamine at $60 a
              bottle, hydrolyzed collagen at $80 a month and joint creams that
              don't penetrate the synovial space where the problem really is.
            </p>
          </FadeIn>

          <FadeIn delay={0.6} data-id="element-130">
            <p data-id="element-131">
              Not because they're bad products. But because they attack the
              symptom without touching the cause.
            </p>
          </FadeIn>
        </div>
      </div>
    </section>;
}